import { verticalBuild } from "../layouts/vertical";
import { slideBuild } from "../layouts/slide";
import { heroBuild } from "../layouts/sky_ocean_hero";

require("../../../../../../themes/custom/wwf/js/src/utilities/objectValuesPolyfill");

(function ($) {
  $.fn.ttw_quiz = function (actionOrOptions) {
    // Holds all defaults and overrides
    let settings;

    // Holds quiz progress
    const quiz = {
      totalQs: 0,
      answeredQs: 0,
      score: 0,
      questionsAnswered: [],
      questionsAnswers: [],
    };

    $(document).ready(function () {
      $(".ttw_quiz_slider_wrapper").slick({
        infinite: false,
        dots: false,
        fade: true,
        arrows: true,
        draggable: true,
        mobileFirst: true,
        nextArrow:
          '<button class="ttw_quiz_slide-button ttw_quiz_slide-next" id="enable-btn">Next</button>',
        prevArrow:
          '<button class="ttw_quiz_slide-button ttw_quiz_slide-prev">Previous</button>',
      });
    });

    // Holds all methods
    const actions = {
      init(options) {
        // Save any options passed
        settings = $.extend(
          {
            // These are the defaults.
            wrapper: $(this),
            classprefix: "ttw_quiz_",
            initCallback() {},
            completeCallback() {},
            quizType: "personality",
            quizLayout: "slide",
            questions: [
              {
                question: "Question one text?",
                color: "red-1",
                answers: [
                  {
                    answer: "Answer 1",
                  },
                  {
                    answer: "Answer 2",
                  },
                  {
                    answer: "Answer 3",
                  },
                  {
                    answer: "Answer 4",
                  },
                ],
                image: false /* If image to be used add string of file path */,
                imageAlt: "",
                imageCredit: "",
              },
            ],
            resultsStrings: {
              incomplete: {
                title: "Please answer all questions to see your results",
                text: "Your score...",
              },
              complete: {
                title: "Results",
                text: "Quiz complete!",
                feedbackActual: {
                  0: "lion",
                  1: "tiger",
                  2: "madrill",
                },
                feedbackTitle: {
                  0: "Must try harder",
                  1: "Could do better",
                  2: "Fantasic stuff",
                },
                feedbackText: {
                  0: "Yes a lion",
                  1: "No a pig",
                  2: "Bwark! A chicken!",
                },
                feedbackImage: {
                  0: "",
                  1: "",
                  2: "",
                },
              },
            },
            leadText: "Tell your friends to join!",
            twitterShareText: "I got lots and lots!",
            whatsAppShareText: "I got lots and lots!",
          },
          options
        );

        // Trigger build of quiz
        actions.initQuiz();
      },

      // Triggers building the quiz on screen then starting
      initQuiz() {
        if (settings.questions.length > 0) {
          if (settings.quizLayout === "vertical") {
            actions.buildVerticalQuiz();
          } else if (settings.quizLayout === "slide") {
            actions.buildSlideQuiz();
          } else if (settings.quizLayout === "sky_ocean_hero") {
            actions.buildHeroQuiz();
          }
          actions.addQuizEvents();
          actions.addStartOverEvent();

          // Fire callback
          settings.initCallback.call(this);
        } else {
          $.error("No questions set on jQuery.ttw_quiz");
        }
      },

      // Builds quiz HTML
      buildVerticalQuiz() {
        verticalBuild($, quiz, settings);
      },

      buildSlideQuiz() {
        slideBuild($, quiz, settings);
      },

      buildHeroQuiz() {
        heroBuild($, quiz, settings);
      },

      // Builds quiz HTML
      buildQuizHTML() {
        let letter = "@";

        for (let i = 0; i < settings.questions.length; i++) {
          // Create element
          const thisQuestion = $("<fieldset></fieldset>")
            .addClass(`${settings.classprefix}question`)
            .addClass(`${settings.classprefix}question_unanswered`)
            .attr("question", i);

          // Populate question text
          const thisQuestionText = $("<legend></legend>")
            .addClass(`${settings.classprefix}question_text`)
            .html(
              `<span class="${settings.classprefix}question_text_string` +
                `"><span class="ttw_quiz_question_number">${i + 1}:</span> ${
                  settings.questions[i].question
                }</span>`
            );

          // If there is an image add that
          if ("image" in settings.questions[i]) {
            const thisImage = $("<span></span>").addClass(
              `${settings.classprefix}question_image`
            );
            thisImage.append(
              $(
                `<img src="${settings.questions[i].image}" alt="${settings.questions[i].imageAlt}">`
              )
            );

            if (settings.questions[i].imageCredit.length > 0) {
              thisImage.append(
                $("<span></span>")
                  .addClass(`${settings.classprefix}question_image_credit`)
                  .html(settings.questions[i].imageCredit)
              );
            }
            thisQuestionText.append(thisImage);
          }

          // If there is an image add that
          if ("video" in settings.questions[i]) {
            thisQuestion.append(
              `<div class="video_wrapper simple_quiz_iframe"><iframe src="${settings.questions[i].video}"></iframe></div>`
            );
          }

          thisQuestion.append(thisQuestionText);

          // Populate answers
          const thisQuestionAnswers = $("<div></div>").addClass(
            `${settings.classprefix}answers`
          );

          // Loop through answers
          for (let j = 0; j < settings.questions[i].answers.length; j++) {
            // Create element
            const thisQuestionAnswer = $("<div></div>")
              .addClass(`${settings.classprefix}answer`)
              .data("question-id", i)
              .data("answer-id", j);

            thisQuestionAnswer.addClass("quiz_wait");

            // Add answer input
            const thisQuestionAnswerInput = $("<input />")
              .attr("type", "radio")
              .addClass(`${settings.classprefix}answer_input`)
              .attr("name", `ttw_answer[${i}]`)
              .attr("id", `ttw_answer-${i}-${j}`);
            thisQuestionAnswer.append(thisQuestionAnswerInput);

            // Add answer text
            const thisQuestionAnswerText = $("<label></label>")
              .attr("for", `ttw_answer-${i}-${j}`)
              .addClass(`${settings.classprefix}answer_text`)
              .html(
                `${String.fromCharCode(letter.charCodeAt() + 1)}: ${
                  settings.questions[i].answers[j].answer
                }`
              );
            thisQuestionAnswer.append(thisQuestionAnswerText);

            // Add answer to question element
            thisQuestionAnswers.append(thisQuestionAnswer);

            letter = String.fromCharCode(letter.charCodeAt() + 1);
          }

          // Add all the answers to the question
          thisQuestion.append(thisQuestionAnswers);

          // Assign this question to the wrapper
          settings.wrapper.addClass(`${settings.classprefix}wrapper`);
          settings.wrapper.append(thisQuestion);

          // Add another question to the quiz total
          quiz.totalQs++;
          letter = "@";
        }

        // Add incomplete results content
        const results = $("<div></div>")
          .attr("id", `${settings.classprefix}results`)
          .addClass(`${settings.classprefix}results`)
          .addClass(`${settings.classprefix}results_incomplete`);
        results.append(
          $("<span></span>")
            .addClass(`${settings.classprefix}results_title`)
            .html(settings.resultsStrings.incomplete.title)
        );
        results.append(
          $("<span></span>")
            .addClass(`${settings.classprefix}results_text`)
            .html(settings.resultsStrings.incomplete.text)
        );
        settings.wrapper.append(results);
      },

      // Adds quiz Events
      addQuizEvents() {
        $(`.${settings.classprefix}question_unanswered`).on(
          "change",
          `.${settings.classprefix}answer_input`,
          function (e) {
            e.preventDefault();
            actions.handleQuizAnswer($(this));
          }
        );
      },

      addStartOverEvent() {
        $(`.${settings.classprefix}start_over`).on(
          "click",
          function clearQuizEvent() {
            $("html, body").animate(
              { scrollTop: $(".ttw_quiz_wrapper").offset().top - 200 },
              1000,
              "swing"
            );
            actions.removeQuizWrapper();
            actions.resetQuestions();
            actions.initQuiz();
          }
        );
      },

      // Removes quiz wrapper element from the DOM
      removeQuizWrapper() {
        $(`.${settings.classprefix}wrapper`).empty();
      },

      // Prevents quiz scores from being carried over
      resetQuestions() {
        quiz.answeredQs = 0;
        quiz.score = 0;
        quiz.questionsAnswered = [];
        quiz.questionsAnswers = [];
        quiz.totalQs = 0;
      },

      // Removes a single questions change events
      removeQuizQuestionEvent(questionElement) {
        questionElement.off("change", `.${settings.classprefix}answer_input`);
      },

      // Does all the quiz magic when an answer is provided
      handleQuizAnswer(answerElement) {
        const questionElement = answerElement.closest(
          `.${settings.classprefix}question`
        );
        const answerParentElement = answerElement.closest(
          `.${settings.classprefix}answer`
        );

        // Handle question styling changes
        questionElement
          .removeClass(`${settings.classprefix}question_unanswered`)
          .addClass(`${settings.classprefix}question_answered`);

        // Handle answer styling changes
        answerParentElement.addClass(`${settings.classprefix}answer_selected`);

        const answerSiblings = answerParentElement.siblings();

        $(answerSiblings).each(function () {
          const inputEl = this.firstChild;
          $(inputEl).prop("disabled", true);
          $(this).addClass("sibling-answer-opacity");
        });

        const thisMark = actions.markAnswer(
          answerParentElement.data("question-id"),
          answerParentElement.data("answer-id")
        );

        if (settings.quizLayout === "slide" || "hero") {
          $(questionElement)
            .find(`.ttw_quiz_slide-answer-container`)
            .children()
            .each(function answerSelect(key, value) {
              $(value).removeClass(`${settings.classprefix}answer_selected`);
            });
        } else {
          $(questionElement)
            .find(`.${settings.classprefix}answers`)
            .children()
            .each(function answerSelect(key, value) {
              $(value).removeClass(`${settings.classprefix}answer_selected`);
            });
        }
        const answerLetterTextWait =
          answerParentElement[0].lastChild.firstChild.firstChild;
        answerLetterTextWait.innerHTML = `
          <svg width="22" height="23">
            <circle cx="10" cy="14" r="9" fill="#FEC01E" />
            <circle cx="10" cy="14" r="6" fill="#000" />
            <circle cx="10" cy="14" r="3" fill="#FEC01E"/>
          </svg>
        `;
        actions.updateQuiz(
          questionElement.attr("question"),
          answerParentElement.data("answer-id")
        );
      },

      // Update the quiz record now a question has been answered
      updateQuiz(question, answer) {
        if (quiz.questionsAnswered.indexOf(question) === -1) {
          // a question has been answered
          quiz.answeredQs++;
          quiz.questionsAnswered.push(question);
        }

        const answers = Object.values(quiz.questionsAnswers);
        const current = answers.filter(function (value) {
          return value.question === question;
        });

        if (current) {
          current.choice = answer;
          quiz.questionsAnswers.splice(question, 0, current);
        } else {
          quiz.questionsAnswers.push({ question, choice: answer });
        }

        if (quiz.answeredQs >= quiz.totalQs) {
          actions.quizComplete();
        }
      },

      // Mark question - returns true if it is correct and the correct index if it isn't
      markAnswer(question, answer) {
        if (settings.questions[question].answers[answer].correct === true) {
          return true;
        }
        for (let i = 0; i < settings.questions[question].answers.length; i++) {
          if (settings.questions[question].answers[i].correct === true) {
            return i;
          }
        }
      },

      // When all questions are answered show the results
      quizComplete() {
        // Show the results
        actions.displayResults();

        $(`.${settings.classprefix}answer_input`).attr("disabled", true);

        $(`.${settings.classprefix}question`).each(function (index, value) {
          actions.removeQuizQuestionEvent($(value));
          $(value).addClass("no_cursor");
        });

        // Fire callback
        settings.completeCallback.call(this);
        Drupal.behaviors.sourceCodeScourer.attach();
      },

      // Show the results
      displayResults() {
        // Update results styling
        const resultsElement = $(`.${settings.classprefix}results`).removeClass(
          `${settings.classprefix}results_incomplete`
        );

        // Get the user's personality
        const iAmA = actions.whatAmI();

        // Update results title and text
        resultsElement
          .find(`.${settings.classprefix}results_title`)
          .remove(`.${settings.classprefix}results_title`);
        resultsElement
          .find(`.${settings.classprefix}results_text`)
          .remove(`.${settings.classprefix}results_text`);
        resultsElement
          .find(`.${settings.classprefix}results_text_container`)
          .remove(`.${settings.classprefix}results_text_container`);

        const completedResultsElement = $("<div></div>").addClass(
          `${settings.classprefix}results_completed`
        );
        resultsElement.append(completedResultsElement);

        // Use score styles to prevent further repetition
        const characterContainer = $("<div></div>").addClass(
          `${settings.classprefix}results_score_container`
        );
        completedResultsElement.append(characterContainer);

        // Add character
        characterContainer.append(
          $("<p></p>")
            .addClass(`${settings.classprefix}results_score`)
            .text(settings.resultsStrings.complete.feedbackTitle[iAmA])
        );

        // Add feedback container
        const feedbackContainer = $("<div></div>").addClass(
          `${settings.classprefix}results_feedback_container`
        );
        completedResultsElement.append(feedbackContainer);

        // Add feedback text
        feedbackContainer.append(
          $("<p></p>")
            .addClass(`${settings.classprefix}results_feedback_text`)
            .html(settings.resultsStrings.complete.feedbackText[iAmA])
        );

        // Add feedback image
        feedbackContainer.addClass("has_image");
        feedbackContainer.append(
          $("<div></div>")
            .addClass(`${settings.classprefix}results_feedback_img_container`)
            .html(
              `<img src="${settings.resultsStrings.complete.feedbackImage[iAmA]}" alt="${settings.resultsStrings.complete.feedbackTitle[iAmA]}" />`
            )
        );

        // Social buttons
        // resultsElement.append(
        //   $("<span></span>")
        //     .addClass(`${settings.classprefix}results_social`)
        //     .addClass(`${settings.classprefix}slide-padding`)
        //     .append(
        //       `<a class="btn btn--3 share--twitter js-promise-sharer" data-share="twitter" ga-event-action="Click" ga-event-category="SimpleQuizShare" ga-event-label="Twitter Share" ga-on="click" href="https://twitter.com/intent/tweet?text=${encodeURIComponent(
        //         settings.twitterShareText.replace(
        //           "%result%",
        //           settings.resultsStrings.complete.feedbackActual[iAmA]
        //         )
        //       )}" target="_blank">Twitter </a> <a class="btn btn--facebook share--facebook js-promise-sharer" data-share="facebook" ga-event-action="Click" ga-event-category="SimpleQuizShare" ga-event-label="Facebook Share" ga-on="click" href="https://www.facebook.com/sharer/sharer.php?u=${
        //         window.location.href
        //       }" target="_blank"> Facebook </a> <a class="btn btn--whatsapp" href="https://web.whatsapp.com/send?text=${encodeURIComponent(
        //         settings.whatsAppShareText.replace(
        //           "%result%",
        //           settings.resultsStrings.complete.feedbackActual[iAmA]
        //         )
        //       )}"data-action="share/whatsapp/share">Whatsapp</a>`
        //     )
        // );

        if (settings.leadText !== undefined) {
          resultsElement.append(
            `<p id ="${settings.classprefix}lead_text">${settings.leadText}</p>`
          );
        }
      },

      whatAmI() {
        let topAnswer = quiz.questionsAnswers.reduce(function (carry, value) {
          const { choice } = value;
          let index = null;

          for (let i = 0; i < carry.length; i++) {
            if (carry[i].choice === choice) {
              index = i;
            }
          }

          if (index === null) {
            carry.push({ choice, count: 1 });
          } else {
            carry[index].count += 1;
          }

          return carry;
        }, []);

        topAnswer = topAnswer.sort(function (a, b) {
          return a.count > b.count ? -1 : 1;
        });

        return topAnswer[0].choice;
      },
    };

    if (actions[actionOrOptions]) {
      return actions[actionOrOptions].apply(
        this,
        Array.prototype.slice.call(arguments, 1) // eslint-disable-line prefer-rest-params
      );
    }
    if (typeof actionOrOptions === "object" || !actionOrOptions) {
      // Default to "init"
      return actions.init.apply(this, arguments); // eslint-disable-line prefer-rest-params
    }
    $.error(`Action ${actionOrOptions} does not exist on jQuery.ttw_quiz`);
  };
})(jQuery);
